export const voucherViewCheck = {
  path: '/api/v1/voucher/batch',
  method: 'GET',
};

export const voucherCreateCheck = {
  path: '/api/v1/voucher/batch',
  method: 'POST',
};

export const voucherReportCheck = {
  path: '/api/v1/voucher/report',
  method: 'GET',
};

export function applyVoucher(tenantId, voucher) {
  return {
    path: 'voucher/apply',
    method: 'POST',
    body: JSON.stringify({ tenant_id: tenantId, voucher }),
  };
}

export function createVoucherBatch(body) {
  return {
    path: 'voucher/batch',
    method: 'POST',
    body: JSON.stringify(body),
  };
}

export function addVoucherToBatch(batchId) {
  return {
    path: `voucher/batch/${batchId}/add`,
    method: 'PUT',
  };
}

export function deleteVoucherBatch(batchId) {
  return {
    path: `voucher/batch/${batchId}`,
    method: 'DELETE',
  };
}

export function searchVoucherBatches(search, contentType) {
  return {
    path: `voucher/batch${search}`,
    accept: contentType,
    method: 'GET',
  };
}

export function updateVoucherBatch(batchId, body) {
  return {
    path: `voucher/batch/${batchId}`,
    method: 'PUT',
    body: JSON.stringify(body),
  };
}

export function getVoucherBatch(batchId) {
  return {
    path: `voucher/batch/${batchId}`,
    method: 'GET',
  };
}

export function getVouchersInBatch(batchId) {
  return {
    path: `voucher/batch/${batchId}/vouchers`,
    method: 'GET',
  };
}

export function createVoucherPdf(batchId) {
  return {
    path: `voucher/batch/${batchId}/pdf`,
    accept: 'application/pdf',
    method: 'GET',
  };
}

export function getVoucherReport(search, contentType, model, id) {
  const url = model && id
    ? `voucher/report/${model}/${id}${search}`
    : `voucher/report${search}`;

  return {
    path: url,
    accept: contentType,
    method: 'GET',
  };
}

export function getGroupedVoucherReport(search, contentType, grouping) {
  return {
    path: `voucher/report/${grouping}${search}`,
    accept: contentType,
    method: 'GET',
  };
}
